import { DataFeed } from '@components/common/DataFeed';
import CoinpaperLogomark from '@components/icons/coinpaperLogomark.svg';
import { urls } from '@consts/images';
import { P } from '@student-coin/coinpaper-components';
import { ReactElement } from 'react';
import { LoaderImage, SearchStateInfoContainer } from './SearchFeed.styles';
import { SearchFeedProps } from './SearchFeed.types';

export function SearchFeed<TData extends { id: string }>({
  noResultsMessage,
  loadingMessage,
  ...dataFeedProps
}: SearchFeedProps<TData>): ReactElement {
  // TODO: check if hasNextPage returns true if data is empty
  return (
    <>
      <DataFeed<TData> {...dataFeedProps} hideHeader />
      {dataFeedProps.loading && (
        <SearchStateInfoContainer>
          <LoaderImage src={urls.searchLoader} alt="loading indicator" />
          <P>{loadingMessage}</P>
        </SearchStateInfoContainer>
      )}
      {!dataFeedProps.data.length && !dataFeedProps.loading && (
        <SearchStateInfoContainer>
          <CoinpaperLogomark />
          <P>{noResultsMessage}</P>
        </SearchStateInfoContainer>
      )}
    </>
  );
}
